/**
 * Каталог станів (conditions) — назви + кольорові маркери.
 * Порт із прототипа conditions.jsx.
 */
import type { ConditionType } from '@sd/shared';

export interface ConditionDef {
  type: ConditionType;
  label: string;
  short: string;
  color: string;
}

export const CONDITIONS: ConditionDef[] = [
  { type: 'downed',      label: 'Збитий',       short: 'збитий',  color: '#9d4f4a' },
  { type: 'silenced',    label: 'Безмовний',    short: 'безмовн', color: '#6f8ca0' },
  { type: 'vulnerable',  label: 'Вразливий',    short: 'вразлив', color: '#cca766' },
  { type: 'poisoned',    label: 'Отруєний',     short: 'отруєн',  color: '#6f8d54' },
  { type: 'hidden',      label: 'Прихований',   short: 'прихов',  color: '#8b7298' },
  { type: 'restrained',  label: 'Скутий',       short: 'скутий',  color: '#b97e44' },
  { type: 'frightened',  label: 'Наляканий',    short: 'наляк',   color: '#9d4f4a' },
  { type: 'prone',       label: 'Лежачий',      short: 'лежач',   color: '#aa9e86' },
];

export const CONDITION_BY_TYPE = new Map(CONDITIONS.map((c) => [c.type, c]));
